import { useEffect, useState } from "react";
import Layout from "../Layout";
import M from 'materialize-css/dist/js/materialize.min';
import { useLocation, useHistory } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa";
import { Helmet } from "react-helmet";

const dpt = {

    appliedArt: {
        courses1: ["Music", "Cosmetology", "Fashion Design", "Art and Design", "Clothing "],
        courses2: ["Cosmetology", "Fashion Design", "Art and Design", "Clothing "],
        courses3: ["Cosmetology", "Fashion Design", "Clothing "],
        nc: "For all NC courses passes in English, Mathematics plus any other three ‘O’ Level subjects. Science required for Cosmetology.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    appliedScience: {
        courses1: ["Science Technology", "Chemical Engineering", "Horticulture", "Industrial Metallurgy"],
        courses2: [ "Sorry, not available but coming soon..." ],
        courses3: [ "Sorry, not available but coming soon..." ],
        nc: "For all NC courses passes in English, Mathematics, Science plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    hospitality: {
        courses1: ["Food & Beverage Service", "Bakery Studies", "Tourism & Hospitality Management", "Professional Cookery "],
        courses2: ["Food & Beverage Service", "Bakery Studies", "Tourism & Hospitality Management", "Professional Cookery "],
        courses3: [ "Tourism & Hospitality Management"],
        nc: "For all NC courses passes in English, Mathematics, Science plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    construction: {
        courses1: ["Brick and Block Laying ", "Painting and Decorating", "Plumbing and Drain Laying", "Carpentry and Joinery", "Wood Machines and Manufacturing"],
        courses2: [ "Construction Technology", "Wood Design and Manufacturing"],
        courses3: [ "Construction Technology", "Wood Design and Manufacturing"],
        nc: "For all NC courses passes in English, Mathematics, Science plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    ced: {
        courses1: ["Civil Engineering", "Quantity Surveying Engineering", "Water Resources & Irrigation Engineering", "Architectural Technology", "Valuation & Estate Management", "Urban and Regional Planning", "Surveying and Geomatics"],
        courses2: ["Civil Engineering", "Quantity Surveying Engineering", "Water Resources & Irrigation Engineering", "Architectural Technology", "Valuation & Estate Management", "Surveying and Geomatics"],
        courses3: ["Sorry, not available but coming soon..."],
        nc: "For all NC courses passes in English, Mathematics, Science plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    automotive: {
        courses1: ["Motor Vehicle Body Repairs + Refinishing", "Motor Vehicle Mechanics", "Automobile Electrics & Electronics"],
        courses2: ["Sorry, not available but coming soon..."],
        courses3: ["Sorry, not available but coming soon..."],
        nc: "For all NC courses passes in English, Mathematics, Science plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    electrical: {
        courses1: ["Electrical Power", "Computer Systems", "Communication Systems", "Instrumentation"],
        courses2: ["Electrical Power"],
        courses3: ["Sorry, not available but coming soon..."],
        nc: "For all NC courses passes in English, Mathematics, Science plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    mechanical : {
        courses1: ["Diesel Plant Fitting", "Fabrication Engineering", "Machine Shop Engineering", "Refrigeration & Air Conditioning", "Technical Graphics"],
        courses2: ["Production Engineering"],
        courses3: ["Mechanical Engineering"],
        nc: "For all NC courses passes in English, Mathematics, Science plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    mining : {
        courses1: ["Drilling and Blasting", "Fundamentals of Mining", "Metallurgical Assaying", "Mineral Processing", "Mine Development and Production", "Mine Ventilation and Environmental Engineering"],
        courses2: ["Sorry, not available but coming soon..."],
        courses3: ["Sorry, not available but coming soon..."],
        nc: "A minimum of five (5) ‘O’ Level subjects at Grade C or better including English Language and Mathematics. At least any one of the following science subjects: (Physics, Chemistry, Integrated/Combined/Core Science, Science(physics/chemistry) and Physical Science).",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    businessStudies : {
        courses1: ["Accountancy", "Banking and Finance"],
        courses2: ["Accountancy", "Banking and Finance"],
        courses3: ["Accountancy", "Banking and Finance"],
        nc: "For all NC courses passes in English, Mathematics plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    managementStudies : {
        courses1: ["Transport & Logistics Management", "Marketing Management", "Human Resources", "Purchasing and Supply"],
        courses2: ["Transport & Logistics Management", "Marketing Management", "Human Resources"],
        courses3: ["Transport & Logistics Management", "Marketing Management", "Human Resources"],
        nc: "For all NC courses passes in English, Mathematics plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    officeManagement : {
        courses1: ["Secretarial"],
        courses2: [ "Office Management"],
        courses3: [ "Office Management"],
        nc: "For all NC courses passes in English, Mathematics plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    imSystems : {
        courses1: ["Information Technology", "Library and Information Science", "Records Management and Info Science"],
        courses2: ["Information Technology", "Library and Information Science", "Records Management and Info Science"],
        courses3: ["Information Technology", "Library and Information Science", "Records Management and Info Science"],
        nc: "For all NC courses passes in English, Mathematics plus any other two ‘O’ Levels subjects.",
        nd: "5 ‘O’ Level passes plus relevant NC qualification.",
        hnd: "5 ‘O’ Level passes plus relevant ND qualification."
    },
    education : {
        courses1: ["Further Education Trainers Certificate"],
        courses2: [ "Further Education Trainers Diploma"],
        courses3: ["Sorry, not available but coming soon..."],
        nc: "For FETC course passes in English; Mathematics plus any other two ‘O’ Level subjects.",
        nd: "For FETD course 5 ‘O’ Levels passes plus FETC.",
        hnd: ""
    },

}
const Department = () => {
    const [departmentName, setDepartmentName] = useState('');
    const [courses1, setCourses1] = useState([]);
    const [courses2, setCourses2] = useState([]);
    const [courses3, setCourses3] = useState([]);
    const [ncRequirements, setNcRequirements] = useState('');
    const [ndRequirements, setNdRequirements] = useState('');
    const [hndRequirements, setHndRequirements] = useState('');

    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        var tabs = document.querySelector('.tab1');
        M.Tabs.init(tabs, {});

        //console.log(history);
        if(location.pathname === '/departments/applied-arts') {
            setDepartmentName('Applied Arts');
            setCourses1(dpt.appliedArt.courses1);
            setCourses2(dpt.appliedArt.courses2);
            setCourses3(dpt.appliedArt.courses3);
            setNcRequirements(dpt.appliedArt.nc);
            setNdRequirements(dpt.appliedArt.nd);
            setHndRequirements(dpt.appliedArt.hnd);
        } else if(location.pathname === '/departments/aplied-science') {
            setDepartmentName('Applied Science');
            setCourses1(dpt.appliedScience.courses1);
            setCourses2(dpt.appliedScience.courses2);
            setCourses3(dpt.appliedScience.courses3);
            setNcRequirements(dpt.appliedScience.nc);
            setNdRequirements(dpt.appliedScience.nd);
            setHndRequirements(dpt.appliedScience.hnd);
        }   else if(location.pathname === '/departments/hospitality') {
            setDepartmentName('Hospitality');
            setCourses1(dpt.hospitality.courses1);
            setCourses2(dpt.hospitality.courses2);
            setCourses3(dpt.hospitality.courses3);
            setNcRequirements(dpt.hospitality.nc);
            setNdRequirements(dpt.hospitality.nd);
            setHndRequirements(dpt.hospitality.hnd);
        }   else if(location.pathname === '/departments/construction' || location.pathname === '/departments/wood-technology') {
            setDepartmentName('Construction and Wood Technology');
            setCourses1(dpt.construction.courses1);
            setCourses2(dpt.construction.courses2);
            setCourses3(dpt.construction.courses3);
            setNcRequirements(dpt.construction.nc);
            setNdRequirements(dpt.construction.nd);
            setHndRequirements(dpt.construction.hnd);
        }  else if(location.pathname === '/departments/ced') {
            setDepartmentName('Civil Engineering');
            setCourses1(dpt.ced.courses1);
            setCourses2(dpt.ced.courses2);
            setCourses3(dpt.ced.courses3);
            setNcRequirements(dpt.ced.nc);
            setNdRequirements(dpt.ced.nd);
            setHndRequirements(dpt.ced.hnd);
        }   else if(location.pathname === '/departments/automotive') {
            setDepartmentName('Automotive');
            setCourses1(dpt.automotive.courses1);
            setCourses2(dpt.automotive.courses2);
            setCourses3(dpt.automotive.courses3);
            setNcRequirements(dpt.automotive.nc);
            setNdRequirements(dpt.automotive.nd);
            setHndRequirements(dpt.automotive.hnd);
        }  else if(location.pathname === '/departments/electrical') {
            setDepartmentName('Electrial');
            setCourses1(dpt.electrical.courses1);
            setCourses2(dpt.electrical.courses2);
            setCourses3(dpt.electrical.courses3);
            setNcRequirements(dpt.electrical.nc);
            setNdRequirements(dpt.electrical.nd);
            setHndRequirements(dpt.electrical.hnd);
            console.log(dpt);
        }  else if(location.pathname === '/departments/mechanical') {
            setDepartmentName('Mechanical');
            setCourses1(dpt.mechanical.courses1);
            setCourses2(dpt.mechanical.courses2);
            setCourses3(dpt.mechanical.courses3);
            setNcRequirements(dpt.mechanical.nc);
            setNdRequirements(dpt.mechanical.nd);
            setHndRequirements(dpt.mechanical.hnd);
        }  else if(location.pathname === '/departments/business-studies') {
            setDepartmentName('Business Studies');
            setCourses1(dpt.businessStudies.courses1);
            setCourses2(dpt.businessStudies.courses2);
            setCourses3(dpt.businessStudies.courses3);
            setNcRequirements(dpt.businessStudies.nc);
            setNdRequirements(dpt.businessStudies.nd);
            setHndRequirements(dpt.businessStudies.hnd);
        }   else if(location.pathname === '/departments/management-studies') {
            setDepartmentName('Management Studies');
            setCourses1(dpt.managementStudies.courses1);
            setCourses2(dpt.managementStudies.courses2);
            setCourses3(dpt.managementStudies.courses3);
            setNcRequirements(dpt.managementStudies.nc);
            setNdRequirements(dpt.managementStudies.nd);
            setHndRequirements(dpt.managementStudies.hnd);
        }   else if(location.pathname === '/departments/office-management') {
            setDepartmentName('Office Management');
            setCourses1(dpt.officeManagement.courses1);
            setCourses2(dpt.officeManagement.courses2);
            setCourses3(dpt.officeManagement.courses3);
            setNcRequirements(dpt.officeManagement.nc);
            setNdRequirements(dpt.officeManagement.nd);
            setHndRequirements(dpt.officeManagement.hnd);
        }  else if(location.pathname === '/departments/im-systems') {
            setDepartmentName('IM Systems');
            setCourses1(dpt.imSystems.courses1);
            setCourses2(dpt.imSystems.courses2);
            setCourses3(dpt.imSystems.courses3);
            setNcRequirements(dpt.imSystems.nc);
            setNdRequirements(dpt.imSystems.nd);
            setHndRequirements(dpt.imSystems.hnd);
        }   else if(location.pathname === '/departments/education') {
            setDepartmentName('Education');
            setCourses1(dpt.education.courses1);
            setCourses2(dpt.education.courses2);
            setCourses3(dpt.education.courses3);
            setNcRequirements(dpt.education.nc);
            setNdRequirements(dpt.education.nd);
            setHndRequirements(dpt.education.hnd);
        }   else if (location.pathname === '/departments/mining') {
            setDepartmentName('Mining');
            setCourses1(dpt.mining.courses1);
            setCourses2(dpt.mining.courses2);
            setCourses3(dpt.mining.courses3);
            setNcRequirements(dpt.mining.nc);
            setNdRequirements(dpt.mining.nd);
            setHndRequirements(dpt.mining.hnd);
        }
    }, [location]);

    return ( 
        <Layout>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>{ departmentName } Department</title>
            </Helmet>
            <div className="light-bg">
                <div className="container pt-5">
                    <h6 className="has-text-weight-semibold mt-6 mb-3 is-size-4">{ departmentName } Department</h6>
                    <div className="divider"></div>   
                    {/* ======= Tabs ========= */}
                    <div className="row mt-5">
                        <div className="col s12 m11">
                            <ul className="tabs tab1">
                                <li className="tab col s3"><a href="#test1" className="active main-color-text has-text-weight-bold">NC</a></li>
                                <li className="tab col s3"><a  href="#test2" className="main-color-text has-text-weight-bold">National Diploma</a></li>
                                <li className="tab col s3"><a href="#test3" className="main-color-text has-text-weight-bold">HND</a></li>
                            </ul>
                        </div>
                        <div id="test1" className="box col s12 m11 mt-6 px-5 py-2">
                            <div className="row">
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Courses</h6>
                                    <ol className="list-number mb-4 ml-4">
                                        {
                                            courses1.length !== 0 && courses1.map(course => (
                                            <li key={course} className="mb-3">{course}</li>
                                        ))
                                        }
                                    </ol>
                                </div>
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Course Duration</h6>
                                    <p className="light mb-4">2 Years</p>
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Mode of Study</h6>
                                    <p className="light">Full time / Part Time</p>
                                </div>
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Entry Requirements</h6>
                                    <p className="block">{ ncRequirements }</p>
                                </div>
                            </div>
                        </div>
                        <div id="test2" className="box col s12 m11 mt-6 px-5 py-2">
                            <div className="row">
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Courses</h6>
                                    <ol className="list-number mb-4 ml-4">
                                        {
                                            courses2.length !== 0 && courses2.map(course => (
                                            <li key={course} className="mb-3">{course}</li>
                                        ))
                                        }
                                    </ol>
                                </div>
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Course Duration</h6>
                                    <p className="light mb-4">1 Years</p>
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Mode of Study</h6>
                                    <p className="light">Full time / Part Time</p>
                                </div>
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Entry Requirements</h6>
                                    <p className="block">{ ndRequirements }</p>
                                </div>
                            </div>
                        </div>
                        <div id="test3" className="box col s12 m11 mt-6 px-5 py-2">
                            <div className="row">
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Courses</h6>
                                    <ol className="list-number mb-4 ml-4">
                                        {
                                            courses3.length !== 0 && courses3.map(course => (
                                            <li key={course} className="mb-3">{course}</li>
                                        ))
                                        }
                                    </ol>
                                </div>
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Course Duration</h6>
                                    <p className="light mb-4">1 Years</p>
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Mode of Study</h6>
                                    <p className="light">Full time / Part Time</p>
                                </div>
                                <div className="col s12 m6 l4">
                                    <h6 className="has-text-weight-bold mt-4 mb-2">Entry Requirements</h6>
                                    <p className="block">{ hndRequirements }</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container center">
                        <div className="control mb-4">
                            <div onClick={() => history.goBack()} className="button is-rounded main-color mt-3 mb-4">
                                <span className="icon">
                                    <FaArrowLeft color="white"/>
                                </span>
                                <span className="white-text">Previous Page</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
     );
}
 
export default Department;